import { Link } from "react-router-dom";
import { useLang, shared, ROUTES, CONTACTS } from "../i18n";

export default function Footer() {
  const { lang } = useLang();
  const t = shared[lang];

  return (
    <footer className="bg-ink text-ivory" data-testid="footer">
      <div className="mx-auto max-w-[1600px] px-6 pt-20 pb-10 md:px-10 md:pt-28">
        <div className="grid gap-14 md:grid-cols-12 md:gap-10">
          <div className="md:col-span-5">
            <div className="font-serif text-2xl font-medium tracking-[0.3em]">NICOLE SRL</div>
            <p className="mt-8 max-w-xs font-serif text-xl font-light italic leading-relaxed text-ivory/80">
              {t.footerTagline}
            </p>
          </div>
          <div className="md:col-span-3">
            <div className="text-[11px] font-medium uppercase tracking-[0.25em] text-ivory/40">
              {t.footerNav}
            </div>
            <ul className="mt-6 space-y-3">
              {ROUTES.map((r) => (
                <li key={r.key}>
                  <Link
                    to={r.path}
                    data-testid={`footer-nav-${r.key}`}
                    className="text-sm text-ivory/70 transition-colors duration-300 hover:text-ivory"
                  >
                    {t.nav[r.key]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <div className="text-[11px] font-medium uppercase tracking-[0.25em] text-ivory/40">
              {t.footerContatti}
            </div>
            <ul className="mt-6 space-y-3 text-sm text-ivory/70">
              <li>{CONTACTS.address}</li>
              <li data-testid="footer-upcoming" className="text-ivory/50">{t.upcoming}</li>
              <li>
                <a href={CONTACTS.phoneHref} data-testid="footer-phone" className="transition-colors duration-300 hover:text-ivory">
                  {CONTACTS.phone}
                </a>
              </li>
            </ul>
            <div className="mt-10 text-[11px] font-medium uppercase tracking-[0.25em] text-ivory/40">
              {t.footerLegal}
            </div>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/privacy-policy" data-testid="footer-privacy" className="text-ivory/70 transition-colors duration-300 hover:text-ivory">
                  {t.privacy}
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" data-testid="footer-cookie" className="text-ivory/70 transition-colors duration-300 hover:text-ivory">
                  {t.cookie}
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-20 flex flex-col gap-3 border-t border-ivory/10 pt-8 text-[11px] uppercase tracking-[0.18em] text-ivory/40 md:flex-row md:items-center md:justify-between">
          <span>© 2022 Nicole Srl — {t.rights}</span>
          <span data-testid="footer-piva">P. IVA 03776830139</span>
          <span>{CONTACTS.address}</span>
        </div>
      </div>
    </footer>
  );
}
